<template>
  <div>
    <b-table
      outlined
      striped
      hover
      :fields="fields"
      :items="filteredDocumentItems"
    >
      <template #cell(documentTitle)="row">
        <b-button
          class="p-0 m-0 border-0 text-left"
          variant="link"
          @click="() => openDocument(row.item.doc)"
        >
          {{ row.item.documentTitle }}
        </b-button>
      </template>
      <template #cell(productNames)="row">
        <template v-for="product in row.item.productNames">
          <TruncatedString :key="product" :text="product" :maxLength="22" />
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
import TruncatedString from '@/components/TruncatedString.vue';

export default {
  name: 'DocumentNotificationsList',
  components: {
    TruncatedString,
  },
  props: {
    fields: Array,
    filteredDocumentItems: Array,
  },
  emits: ['openDocument'],
  methods: {
    openDocument(doc) {
      this.$emit('openDocument', doc);
    },
  },
};
</script>

<style scoped></style>
